const utils = {
  methods: {
  },
};

export default utils;
